import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { MdEdit } from "react-icons/md";
import { sentenceCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { Chip, Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.sprintexBlue};
  color: ${colors.sprintexBlue};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.sprintexBlue};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  campaigns,
  component,
  categorize,
  setPage,
  setSearchKey,
  loading,
}) {
  const navigate = useNavigate();
  let columns = [
    { name: "campaign_name", label: "Campaign Name" },
    {
      name: "camapign_period",
      label: "Campaign Period",
    },
    {
      name: "conversion_type",
      label: "Conversion Type",
    },
    {
      name: "budget",
      label: "Campaign Budget",
    },
    { name: "campaignStatus", label: "Status" },
    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "budget") {
      return row.min_budget + "-" + row.max_budget;
    }

    if (col.name === "camapign_period") {
      return (
        convertDate(row.start_duration) + " - " + convertDate(row.end_duration)
      );
    }

    if (col.name === "campaignStatus") {
      let color;
      let background;
      if (
        value === "REQUESTED" ||
        value === "CREATED" ||
        value === "APPROVAL_REQUESTED" ||
        value === "LIVE_REQUESTED"
      ) {
        color = colors.warning;
        background = colors.lightWarning;
      }

      if (
        value === "OFFER_ACCEPTED" ||
        value === "ACTIVE" ||
        value === "ACCEPTED" ||
        value === "PARTIAL_ACCEPTED" ||
        value === "SIZE_READY"
      ) {
        color = colors.success;
        background = colors.lightSuccess;
      }

      if (value === "INITIATED" || value === "SIZING_IN_PROGRESS") {
        color = colors.purple;
        background = colors.lightPurple;
      }

      if (
        value === "REJECTED" ||
        value === "Expired" ||
        value === "FAILED" ||
        value === "MISSED" ||
        value === "PARTIAL_REJECTED"
      ) {
        color = colors.error;
        background = colors.lightError;
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: background,
            color: color,
          }}
          label={sentenceCase(value?.replace(/_/g, " "))}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Campaign">
            <Icon>
              <CgEye
                onClick={() => handleRedirection(row, "view")}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>

          {component === "" &&
            row.status !== "REQUESTED" &&
            row.status !== "ACTIVE" &&
            row.status !== "INITIATED" &&
            row.isEditable && (
              <Tooltip title="Edit Campaign">
                <Icon onClick={() => handleRedirection(row, "edit")}>
                  <MdEdit style={{ height: "20px", width: "20px" }} />
                </Icon>
              </Tooltip>
            )}
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar setPage={setPage} setSearchKey={setSearchKey} />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={campaigns}
        />
      </Grid>
    </Grid>
  );

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  function handleRedirection(campaign, mode) {
    if (component === "request") {
      navigate(
        pages.campaignRequestDetails.route +
          campaign.sender_campaignId +
          "?brandID=" +
          campaign.sender_brandId +
          "&mode=" +
          mode
      );
    }

    if (component === "superadmin") {
      navigate(
        pages.superAdminCampaignDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode,
        { state: { categorize: categorize } }
      );
    }

    if (component === "accepted") {
      navigate(
        pages.campaignAcceptedDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode
      );
    }

    if (component === "") {
      navigate(
        pages.campaignDetails.route + campaign.campaign_id + "?mode=" + mode
      );
    }
  }
}

export function ToolBar({ setPage, setSearchKey }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>
    </div>
  );
}
